import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import FundingPage from "../pages/funding/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <FundingPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
